import React, { useState, useEffect, useRef, useCallback, useMemo } from "react";
import {
  Dialog,
  DialogContent,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Slide,
  TextField,
} from "@mui/material"; 
import { debounce } from "lodash";
import { FaTreeCity } from "react-icons/fa6";
import { MdLocationPin } from "react-icons/md";
import { IoIosArrowRoundBack } from "react-icons/io";
import { IoIosCloseCircle } from "react-icons/io";

const BookingSectionAutoCmplSmallScreen = React.memo(
  ({ open, onClose, value, setValue, cityData, fuse, label }) => {
    const [inputValue, setInputValue] = useState(value?.CityName || "");
    const [filteredOptions, setFilteredOptions] = useState([]);
    const [ready, setReady] = useState(false);
    const inputRef = useRef(null);

    // --- Focus & lazy render after dialog transition ---
    useEffect(() => {
      //console.log(filteredOptions);

    
      if (open) {
        setReady(false);
        if(filteredOptions.length === 0){
            setFilteredOptions(cityData);
        }
        
        
        const timeout = setTimeout(() => {
          setReady(true);
          inputRef.current?.focus();
          if(value?.CityName){
            setInputValue(value?.CityName); 
           
          }
        }, 300); // matches transition duration
        return () => clearTimeout(timeout);
      } else {
        setInputValue(value?.CityName || "");   
        // setFilteredOptions([]);
      }
    }, [open]);

    // useEffect(() => {
    //   console.log("input changed:", inputValue); 
    //   setInputValue(inputValue);
    // }, [inputValue]);

    // useEffect(() => {
    //   console.log("value changed:", value); 
    // }, [value]);

    // --- Core search function ---
    const customSearch = useCallback(
      (query) => {
        if (!query) return cityData;

        const lowerQuery = query.toLowerCase();

        // single letter: faster startsWith filter
        if (/^[a-z]$/i.test(query)) {
          return cityData.filter((c) =>
            c.CM_CityName.toLowerCase().startsWith(lowerQuery)
          );
        }

        // fuzzy search
        const fuseResults = fuse.search(query).map((r) => r.item);
        return fuseResults;
      },
      [cityData, fuse]
    );

    // --- Debounced search ---
    const debouncedSearch = useMemo(
      () =>
        debounce((query, updateResults) => {
          const results = customSearch(query);
         // console.log("Results:", results);
          updateResults(results);
        }, 200),
      [customSearch]
    );

    useEffect(() => {
      //console.log("Searching for:", inputValue);
      debouncedSearch(inputValue, setFilteredOptions);
      return () => debouncedSearch.cancel();
    }, [inputValue, debouncedSearch]);


    const handleClose = () => {
      // if user didn’t pick a new valid city, keep old value
      onClose();
    };



    const sendEventTobackend = (eventName, eventValue , eventFrom ) =>{

      let deviceId = null;
      let deviceDaySession = null

      if(window.SessionConstants.DEVICE_INFO_KEY ){
          deviceId =localStorage.getItem(window.SessionConstants.DEVICE_INFO_KEY);
      }

      if(window.SessionConstants.DEVICE_SESSION_KEY){
         deviceDaySession = JSON.parse(localStorage.getItem(window.SessionConstants.DEVICE_SESSION_KEY)); 
      }

       
      console.log(eventName);
      console.log(toSafeString(eventValue));
      console.log(eventFrom);


      console.log(deviceId);
      console.log(deviceDaySession);
  }


  function toSafeString(value) {
  if (value === null || value === undefined) {
    return "";
  }

  if (typeof value === "string") {
    return value;
  }

  try {
    return JSON.stringify(value);
  } catch (e) {
    return String(value);
  }
}


    return (
      <Dialog fullScreen open={open} onClose={onClose} TransitionComponent={Slide}>
        <div
          style={{
            padding: 16,
            background: "#fff",
            height: "100vh",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div style={{ display: "flex", flexDirection:"column" }}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",width:"100%",fontSize:"28px"}}>
              <span  onClick={()=>{
                handleClose();
              }}>
                  <IoIosArrowRoundBack />
              </span>

              <span onClick={()=>{
                 handleClose();
              }}>
              <IoIosCloseCircle /> 
              </span>

            </div>
            <TextField
              inputRef={inputRef}
              fullWidth
              label={label}
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              variant="outlined"
              size="large"
              autoFocus
            />
          </div>

          {ready && (
            <DialogContent style={{ padding: 0, overflowY: "auto" }} >
              <List sx={{ width: "100%" }} >
                { filteredOptions.slice(0, 60).map((option, index) => (
                  <ListItem
                    key={`${option.CM_CityID}-${index}`}
                    disablePadding
                    onClick={() => {
                     inputRef.current?.blur();
                      
                      setTimeout(() => {
                        setValue(option);
                        onClose();
                      }, 10);
                    }}
                  >
                    <ListItemButton>
                      <ListItemIcon style={{ fontSize: "25px" }}>
                        { !option.isBoardingPoint ? (
                          <small className="icon">
                            <FaTreeCity />
                          </small>
                        ) : (
                          <small className="icon">
                            <MdLocationPin />
                          </small>
                        )}
                      </ListItemIcon>
                      <ListItemText primary={option.CityName} />
                    </ListItemButton>
                  </ListItem>
                ))}
                {filteredOptions.length === 0 && inputValue && (
                  <ListItem>
                    <ListItemText primary="No results found" />
                  </ListItem>
                )}
              </List>
            </DialogContent>
          )}
        </div>
      </Dialog>
    );
  }
);

export default BookingSectionAutoCmplSmallScreen;
